import { motion } from "framer-motion";
import clsx from "clsx";

const Button = ({
  children,
  big,
  fontBig,
  inverse,
  disabled,
  className,
  ...props
}) => {
  return (
    <motion.button
      {...props}
      disabled={disabled}
      className={clsx(
        "font-semibold rounded-full transition duration-200 ease-in-out flex items-center justify-center",
        big ? "py-3 px-8" : "py-2 px-6",
        fontBig ? "text-base" : "text-sm",
        inverse
          ? "bg-textGray text-gray-700 dark:bg-neutral-700 dark:text-white"
          : "bg-[#fed693] text-[#ca7100]",
        disabled &&
          " cursor-not-allowed pointer-events-none bg-textGray text-gray-700 dark:bg-neutral-700 dark:text-white",
        className
      )}
    >
      {children}
    </motion.button>
  );
};

export default Button;
